export const UPPER_PRIMARY_SUBJECT_MAP = {
  6: [17, 23, 29, 30, 31, 32, 33, 64, 67, 68],
  7: [17, 23, 26, 29, 31, 32, 33, 64, 67, 68],
  8: [17, 23, 26, 29, 31, 32, 33, 64, 67, 68],
};

const normalizeSem = (value) => {
  if (value == null) return null;
  if (typeof value === "number") return value;
  const str = String(value).trim().toLowerCase();

  if (str === "1" || str === "sem 1" || str === "sem1" || str === "semester 1" || str === "semester1") {
    return 1;
  }
  if (str === "2" || str === "sem 2" || str === "sem2" || str === "semester 2" || str === "semester2") {
    return 2;
  }
  return null;
};

const getItemSem = (item) => {
  return normalizeSem(
    item?.sem ??
      item?.semester ??
      item?.session ??
      item?.satr ??
      item?.term ??
      item?.semister
  );
};

export const filterUpperPrimarySubjects = (subjects, standardIndex, selectedSem) => {
  const allowedIds = UPPER_PRIMARY_SUBJECT_MAP[Number(standardIndex)];
  if (!allowedIds) return [];

  const filteredByStandard = (subjects || []).filter((item) =>
    allowedIds.includes(Number(item?.id))
  );

  const hasSemData = filteredByStandard.some((item) => getItemSem(item) != null);
  if (!hasSemData) return filteredByStandard;

  const sem = Number(selectedSem);
  return filteredByStandard.filter((item) => getItemSem(item) === sem);
};
